import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getRadius, getSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { extractStyleProps } from "./auth-service-tools237.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { InlineInput, InlineInputClasses } from "./auth-service-tools315.js";
import { useSwitchGroupContext } from "./auth-service-tools408.js";
import { SwitchGroup } from "./auth-service-tools409.js";
import classes from "./auth-service-tools410.js";
import { useId } from "./auth-service-tools271.js";
import { useUncontrolled } from "./auth-service-tools323.js";
const defaultProps = {
  labelPosition: "right"
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    radius,
    color,
    size
  } = _ref;
  return {
    root: {
      "--switch-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--switch-height": getSize(size, "switch-height"),
      "--switch-width": getSize(size, "switch-width"),
      "--switch-thumb-size": getSize(size, "switch-thumb-size"),
      "--switch-label-font-size": getSize(size, "switch-label-font-size"),
      "--switch-track-label-padding": getSize(size, "switch-track-label-padding"),
      "--switch-color": color ? getThemeColor(color, theme) : void 0
    }
  };
});
const Switch = factory((_props, ref) => {
  var _a;

  const props = useProps("Switch", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    color,
    label,
    offLabel,
    onLabel,
    id,
    size,
    radius,
    wrapperProps,
    thumbIcon,
    checked,
    defaultChecked,
    onChange,
    labelPosition,
    description,
    error,
    disabled,
    variant,
    rootRef,
    mod,
    ...others
  } = props;
  const ctx = useSwitchGroupContext();

  const _size = size || (ctx == null ? void 0 : ctx.size);

  const getStyles = useStyles({
    name: "Switch",
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const {
    styleProps,
    rest
  } = extractStyleProps(others);
  const uuid = useId(id);
  const contextProps = ctx ? {
    checked: ctx.value.includes(rest.value),
    onChange: ctx.onChange
  } : {};
  const [_checked, handleChange] = useUncontrolled({
    value: (_a = contextProps.checked) != null ? _a : checked,
    defaultValue: defaultChecked,
    finalValue: false
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(InlineInput, { ...getStyles("root"),
    __staticSelector: "Switch",
    __stylesApiProps: props,
    id: uuid,
    size: _size,
    labelPosition,
    label,
    description,
    error,
    disabled,
    bodyElement: "label",
    labelElement: "span",
    classNames,
    styles,
    unstyled,
    "data-checked": contextProps.checked || void 0,
    variant,
    ref: rootRef,
    mod,
    ...styleProps,
    ...wrapperProps,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("input", { ...rest,
      disabled,
      checked: _checked,
      onChange: event => {
        var _a2;

        ctx ? (_a2 = contextProps.onChange) == null ? void 0 : _a2.call(contextProps, event) : onChange == null ? void 0 : onChange(event);
        handleChange(event.currentTarget.checked);
      },
      id: uuid,
      ref,
      type: "checkbox",
      role: "switch",
      ...getStyles("input")
    }), /* @__PURE__ */jsxRuntimeExports.jsxs(Box, {
      "aria-hidden": "true",
      mod: {
        error,
        "label-position": labelPosition,
        "without-labels": !onLabel && !offLabel
      },
      ...getStyles("track"),
      children: [/* @__PURE__ */jsxRuntimeExports.jsx(Box, {
        component: "span",
        mod: "reduce-motion",
        ...getStyles("thumb"),
        children: thumbIcon
      }), /* @__PURE__ */jsxRuntimeExports.jsx("span", { ...getStyles("trackLabel"),
        children: _checked ? onLabel : offLabel
      })]
    })]
  });
});
Switch.classes = { ...classes,
  ...InlineInputClasses
};
Switch.displayName = "@mantine/core/Switch";
Switch.Group = SwitchGroup;
export { Switch };